module.exports = __webpack_public_path__ + "img/tpc-18.2a17fe18.jpg";